// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2m5kB","location":"Header_location__4DMAv"};